import { Login, GoogleLoginData } from './loginType';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class LoginApi {

  static async login_google(token: string, companyCode: string) {
    try {
      const response = await fetch(`${API_BASE_URL}/google_login`,
        {
          method: 'POST', credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token,
            company_code: companyCode, // Ensure consistent naming
          }),
        });

      const responseBody = await response.json();

      if (response.status === 200) {
        //console.log("login===", responseBody);

        return responseBody;
      }
      else {
        //console.log('body======', responseBody.error, `Status ${response.status}`);

        //throw new Error(response.statusText || `Error: Status ${response.status}`);
        //throw new Error(`login error: status ${response.status}`);
        if (responseBody.code === 'x-404') {
          // Throw a new error with the custom message and the error code
          throw new Error(`Login error: status ${response.status}. ${responseBody.error} (Code: ${responseBody.code})`);
        } else {
          // If the error code is not 'x-404', throw a generic error
          throw new Error(`Login error: status ${response.status}. ${responseBody.error}`);
        }
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Login error: ${error.message}`);
      } else {
        throw new Error('Login error: An unknown error occurred.');
      }
    }
  }

  static async login(myLogin: Login) {
    try {
      const response = await fetch(`${API_BASE_URL}/login`,
        {
          method: 'POST',
          credentials: 'include',  // This is crucial for cookies
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(myLogin),
        });

      const responseBody = await response.json();

      if (response.status === 200) {
        //console.log("login===", responseBody);

        return responseBody;
      }
      else {
        //console.log('body======', responseBody.error, `Status ${response.status}`);

        //throw new Error(response.statusText || `Error: Status ${response.status}`);
        throw new Error(`login error: status ${response.status}`);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Login error: ${error.message}`);
      } else {
        throw new Error('Login error: An unknown error occurred.');
      }
    }
  }


  static async logout() {
    try {
      const response = await fetch(`${API_BASE_URL}/logout`,
        {
          method: 'POST',
          credentials: 'include',  // This is crucial for cookies
          headers: {
            'Content-Type': 'application/json',
          },
        });

      const responseBody = await response.json();

      if (response.status === 200) {
        return;
      }
      else {
        throw new Error(`logout error: status ${response.status}`);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Logout error: ${error.message}`);
      } else {
        throw new Error('Logout error: An unknown error occurred.');
      }
    }
  }

  static async updatePassword(token: string, password: string): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/password_resets/${token}/update_password`, {
        method: 'PATCH',
        //credentials: 'include',  // For cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: password
        })
      });

      const responseBody = await response.json();

      if (response.status === 200) {
        return;
      } else if (response.status === 400 && responseBody.error?.includes('expired')) {
        throw new Error('This password reset link has expired. Please request a new one.');
      } else if (response.status === 404) {
        throw new Error('Invalid reset token. Please request a new password reset link.');
      } else {
        throw new Error(responseBody.error || 'Failed to reset password. Please try again.');
      }
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      } else {
        throw new Error('An unknown error occurred while resetting password.');
      }
    }
  }

  static async validateResetToken(token: string) {
    try {
      // Validate password reset token

      // Send the request to the backend
      const response = await fetch(`${API_BASE_URL}/password_resets/validate`, {
        method: 'POST',
        credentials: 'include',  // If you need to send cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: token,
        }),
      });

      // Parse the response
      const responseBody = await response.json();

      // Handle success
      if (response.status === 200) {
        return responseBody;
      } else {
        // Handle errors
        throw new Error(responseBody.error || response.statusText);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to validate token: ${error.message}`);
      } else {
        throw new Error('Failed to validate token: An unknown error occurred.');
      }
    }
  }

  static async resetPassword(loginId: string, email: string, sendMethod: string): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/password_resets`, {
        method: 'POST',
        //credentials: 'include',  // For cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          login_id: loginId,  // Snake case for Rails backend
          email: email,
          send_method: sendMethod
        })
      });

      const responseBody = await response.json();

      if (response.status === 200) {
        return;
      } else {
        throw new Error(`Password reset request failed: status ${response.status} - ${responseBody.message} `);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Password reset error: ${error.message}`);
      } else {
        throw new Error('Password reset error: An unknown error occurred.');
      }
    }
  }

}

export default LoginApi;